import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { ListItemText, Tooltip, Typography } from "@mui/material";
import {
  deleteModelesRapport,
  IModeleRapport,
  IPlanItem,
  updateModeleRapport,
} from "../store/modeleRapportSlice";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../store";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";

import { Grid, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import CircularProgress from "@mui/material/CircularProgress";
import { errorNotify, successNotify } from "../util/functions";
import ConfirmAction from "../components/Common/ConfirmAction";
import EditModele from "./EditModele";
import CheckIcon from "@mui/icons-material/Check";
import MenuRapport from "./MenuRapport";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import FileDownloadIcon from '@mui/icons-material/FileDownload';


export interface IAfficheContenuPlanProps {
  setObjetModele: any;
  setRenderModeleEditable: any;
  setLibelleModeleRapport: any;
  objetModele: any;
  modelesSelected: any;
  setModelesSelected: any;
  // addUserLoading: boolean;
  // setAddUserLoading: any;
  libelleModeleRapport: any;
  libelleModeleRapportToEdit: any;
  setLibelleModeleRapportToEdit: any;
}
const ListeModeleRapport = (props: IAfficheContenuPlanProps) => {
  const {
    setObjetModele,
    setRenderModeleEditable,
    setLibelleModeleRapport,
    objetModele,
    // handleSendOnline,
    modelesSelected,
    setModelesSelected,
    // addUserLoading,
    // setAddUserLoading,
    libelleModeleRapport,
    libelleModeleRapportToEdit,
    setLibelleModeleRapportToEdit,
  } = props;

  const dispatch = useDispatch();
  const { filteredModelesRapport } = useSelector(
    (state: IReduxState) => state.modeleRapport
  );

  //hooks
  const [generateLoading, setGenerateLoading] = useState(false)

  const isSelected: any = (id: string) => modelesSelected.indexOf(id) !== -1;
  const handleClick = (event: any, id: string) => {
    const selectedIndex: number = modelesSelected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(modelesSelected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(modelesSelected.slice(1));
    } else if (selectedIndex === modelesSelected.length - 1) {
      newSelected = newSelected.concat(modelesSelected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        modelesSelected.slice(0, selectedIndex),
        modelesSelected.slice(selectedIndex + 1)
      );
    }
    setModelesSelected(newSelected);
  };

  const generateJsonFile = async () => {
    try {
      setGenerateLoading(true)
      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/creermodelejson", {});
      if (res.status === 1) successNotify("Fichier JSON généré avec succès.");
    } catch (error: any) {
      errorNotify("Erreur lors de la création du fichier json.");
      console.log("🚀 ~ file: ListeModeleRapport.tsx:97 ~ generateJsonFile ~ error", error)
    } finally {
      setGenerateLoading(false)
    }
  }

  return (
    <>
      <div
        style={{
          padding: 10,
          height: "55vh",
          overflow: "auto",
        }}
      >

        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <Box style={{ display: "flex", justifyContent: "flex-end" }} >
            <LoadingButton
              loading={generateLoading}
              loadingPosition="start"
              startIcon={<FileDownloadIcon />}
              variant="outlined"
              size="small"
              onClick={generateJsonFile}
            >
              Générer json
            </LoadingButton>
          </Box>
          <List dense={true}>
            {filteredModelesRapport.map((item, i: number) => {
              const isItemSelected: boolean = isSelected(item.idModeleRapport);
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      <MenuRapport
                        item={item}
                        setRenderModeleEditable={setRenderModeleEditable}
                        setLibelleModeleRapport={setLibelleModeleRapport}
                        objetModele={objetModele}
                        libelleModeleRapport={libelleModeleRapport}
                        libelleModeleRapportToEdit={libelleModeleRapportToEdit}
                        setLibelleModeleRapportToEdit={
                          setLibelleModeleRapportToEdit
                        }
                        setObjetModele={setObjetModele}
                      />
                    }
                  >
                    <ListItem>
                      <ListItemIcon>
                        {item.modificationMiseEnLigne === 1 ? (
                          // <Tooltip title="Ce modèle de rapport est déjà en ligne">
                          <TaskAltIcon
                            color="primary"
                            fontSize="small"
                            style={{ marginLeft: 12 }}
                          />
                        ) : (
                          // </Tooltip>
                          <TaskAltIcon
                            color="action"
                            fontSize="small"
                            style={{ marginLeft: 12 }}
                          />

                          // <Checkbox
                          //   size="small"
                          //   onClick={(event) =>
                          //     handleClick(event, item.idModeleRapport)
                          //   }
                          //   color="primary"
                          //   checked={isItemSelected}
                          // />
                        )}
                      </ListItemIcon>
                      <ListItemButton>
                        <ListItemText
                          primary={item.libelleModeleRapport}
                          secondary={
                            <>
                              <Typography variant="caption">
                                {`Révision: ${item.revision} - `}
                              </Typography>
                              <Typography variant="caption">
                                {`Identifiant du modèle: ${item.idModeleRapport} - `}
                              </Typography>
                              <Typography variant="caption">
                                {
                                  `Disponibilité en ligne: ${item.modificationMiseEnLigne === 1 ? "Oui" : "Non"} - `
                                }
                              </Typography>
                              <Typography variant="caption">
                                {
                                  `Autorisation de génération de rapport depuis ce modèle: ${ item.status === 2 ? "Oui" : "Non"}`
                                }
                              </Typography>
                            </>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        {/* {modelesSelected.length > 0 && (
          <Grid style={{ marginTop: 10 }}>
            <LoadingButton
              loadingPosition="end"
              loading={addUserLoading}
              endIcon={<SendIcon />}
              size="small"
              variant="contained"
              onClick={handleSendOnline}
            >
              Publier
            </LoadingButton>
            {}
          </Grid>
        )} */}
      </Grid>
    </>
  );
};
export default ListeModeleRapport;
